module.exports = __webpack_public_path__ + "static/media/isa6.bfcc29e1.png";